import script from "./share-with-pulse-users-additional-information.vue?vue&type=script&setup=true&lang=ts"
export * from "./share-with-pulse-users-additional-information.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__